

/* ---- */

(function(){
  var root = document.querySelector('[data-rf-bb]');
  var dataEl = document.querySelector('[data-rf-data]');
  if(!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  /* declared up here so the first buildTiles() already sees it */
  window.RF_PDP = window.RF_PDP || {};
  window.RF_PDP.hooks = window.RF_PDP.hooks || [];
  /* micro_shared arrives via newline_to_br — strip tags and whitespace */
  D.microShared = (D.microShared || []).map(function(s){ return s.replace(/<[^>]*>/g,'').trim(); }).filter(Boolean);

  window.dataLayer = window.dataLayer || [];
  function track(ev, data){ try{ dataLayer.push(Object.assign({event:'rf_'+ev}, data||{})); }catch(e){} }

  function money(cents){
    return D.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, (cents/100).toFixed(2).replace(/\.00$/,''));
  }
  var MODE = D.discountMode; /* 'none' | 'multi' | 'all' */
  var PCT = D.discountPct/100;
  function disc(cents){ return Math.round(cents*(1-PCT)); }
  function tag(cents, isMulti){
    if(MODE==='all' || (MODE==='multi' && isMulti)){
      return '<s>'+money(cents)+'</s> '+money(disc(cents));
    }
    return money(cents);
  }
  /* every threshold comparison runs post-discount when any discount mode is on:
     Shopify checks price-based shipping rates AFTER the code applies */
  function shipDomain(cents){ return MODE==='none' ? cents : disc(cents); }

  /* ---------- shape the variant list ---------- */
  function shortName(t){
    return t.replace(/\s*\(.*$/,'').replace(/\s*Magnetic Closure/i,'').replace(/Hybrid\/Utility/i,'Hybrid').trim();
  }
  function fitLine(t){
    var s=t.toLowerCase();
    if(s.indexOf('mallet')>-1) return D.fit.mallet || D.fit.putter;
    if(s.indexOf('putter')>-1) return D.fit.putter;
    if(s.indexOf('driver')>-1) return D.fit.driver;
    if(s.indexOf('fairway')>-1) return D.fit.fairway;
    if(s.indexOf('hybrid')>-1) return D.fit.hybrid;
    return '';
  }
  var variants = D.variants.map(function(v){
    return {
      id: v.id, title: v.title, name: v.name || shortName(v.title), price: v.price,
      ok: v.available, mediaIndex: v.mediaIndex,
      /* some mallet covers are named "Center Shaft Mallet" with no "putter" in the title */
      group: /putter|mallet/i.test(v.title) ? 'putter' : 'club',
      fit: fitLine(v.title)
    };
  });

  /* ---------- sets ----------------------------------------------------
     A set has to BE a set, and it has to say why it is worth taking.

     Naming: the woods travel together when the driver is in stock ("The
     woods"); otherwise whatever is available is offered as "Everything in
     stock". Never a raw "Hybrid + Mallet Putter" label — that reads as a
     leftovers bin, which is what it looked like before.

     Reason line, strongest true one wins:
       1. a real saving — ad pricing, or the store's own multi-buy discount
          (multibuy_pct, set once in the theme editor to match the automatic
          discount in Shopify; the moment it exists, organic sees it too)
       2. the order genuinely reaches free shipping
       3. completeness — the documented motive: 855 of 4,782 reviewers own two
          or more, and the VoC is full of "complete the set". That is a real
          reason to take the matching size now, so the tile always shows.
  -------------------------------------------------------------------- */
  var MULTI = (D.multibuyPct || 0)/100;
  var availWoods, availAll, hasDriver;
  availWoods = variants.filter(function(v){return v.group==='club'&&v.ok;});
  availAll = variants.filter(function(v){return v.ok;});
  hasDriver = availWoods.some(function(v){return /driver/i.test(v.title);});
  var sets = [];
  function mkSet(parts, key, name){
    return {
      isSet:true, key:key, parts:parts, name:name,
      price: parts.reduce(function(a,p){return a+p.price;},0),
      count: parts.length
    };
  }
  if(!D.noSets && hasDriver && availWoods.length>=2){
    sets.push(mkSet(availWoods,'woods',D.labels.setWoods));
  }
  /* noSets: a polo or an accessory has sizes or colours, not a matching set */
  if(!D.noSets && availAll.length>=2){
    sets.push(mkSet(availAll,'all',D.labels.setAll));
  }
  /* saving on a multi-item order: ad pricing first, then the store's own rule */
  function setSave(cents){
    if(MODE!=='none') return cents - disc(cents);
    if(MULTI>0) return Math.round(cents*MULTI);
    return 0;
  }
  function setNet(cents){ return cents - setSave(cents); }
  /* mutate in place: applyStock() below holds a reference to this same array */
  sets.slice().forEach(function(s,i){
    if(sets.findIndex(function(x){return x.count===s.count;})!==i){ sets.splice(sets.indexOf(s),1); return; }
    var save=setSave(s.price);
    if(save>0){ s.reason='Save '+money(save); }
    else if(shipDomain(s.price)>=D.freeShip){ s.reason=D.labels.freeShipHit; }
    else { s.reason=D.labels.setReason; }
  });

  var selected = variants.find(function(v){return v.ok;}) || variants[0];
  var giftOn = false;

  /* ---------- gallery ---------- */
  var track_ = root.querySelector('[data-rf-track]');
  var slides = [].slice.call(root.querySelectorAll('[data-rf-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-rf-thumb]'));
  var dotsBox = root.querySelector('[data-rf-dots]');
  var gIndex = 0;
  slides.forEach(function(s,i){
    var d=document.createElement('button'); d.type='button';
    if(i===0) d.className='is-active';
    d.onclick=function(){ goSlide(i); };
    dotsBox.appendChild(d);
  });
  var dots=[].slice.call(dotsBox.children);
  function markSlide(i){
    gIndex=i;
    thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===i);});
    dots.forEach(function(d,n){d.classList.toggle('is-active',n===i);});
  }
  function goSlide(i){
    i=Math.max(0,Math.min(slides.length-1,i));
    var left=track_.clientWidth*i;
    /* The track is scroll-snap-type: x mandatory. In Chrome the snap engine
       cancels a smooth programmatic scroll and re-snaps to where it already
       was, so the arrows, the thumbnails and picking a size all left the photo
       on slide 0 — measured: scrollTo(368,'smooth') ended at 0, the same call
       with behavior 'auto' ended at 368. Try the animation, then make sure the
       move actually happened. */
    try { track_.scrollTo({left:left,behavior:'smooth'}); }
    catch(e) { track_.scrollLeft=left; }
    setTimeout(function(){
      if(Math.abs(track_.scrollLeft-left)>8) track_.scrollLeft=left;
    },420);
    markSlide(i);
  }
  thumbs.forEach(function(t){ t.onclick=function(){ goSlide(+t.getAttribute('data-rf-thumb')); }; });
  root.querySelector('[data-rf-prev]').onclick=function(){goSlide(gIndex-1);};
  root.querySelector('[data-rf-next]').onclick=function(){goSlide(gIndex+1);};
  var tick;
  track_.addEventListener('scroll',function(){
    clearTimeout(tick);
    tick=setTimeout(function(){
      var i=Math.round(track_.scrollLeft/track_.clientWidth);
      if(i!==gIndex && slides[i]) markSlide(i);
    },90);
  });

  /* lightbox */
  var lb=root.querySelector('[data-rf-lb]'), lbImg=root.querySelector('[data-rf-lb-img]'),
      lbCount=root.querySelector('[data-rf-lb-count]'), lbIndex=0;
  function lbGo(i){
    if(lbImg) lbImg.alt = D.productTitle;
    lbIndex=(i+slides.length)%slides.length;
    lbImg.src=slides[lbIndex].querySelector('img').src;
    lbCount.textContent=(lbIndex+1)+' / '+slides.length;
  }
  slides.forEach(function(s,i){ s.onclick=function(){ lbGo(i); lb.classList.remove('is-solo'); lb.classList.add('is-show'); document.body.style.overflow='hidden'; }; });
  var lbVideoWrap=root.querySelector('[data-rf-lb-videowrap]');
  var lbVideo=root.querySelector('[data-rf-lb-video]');
  function soloOpen(){ return lb.classList.contains('is-solo'); }
  function closeLb(){
    lb.classList.remove('is-show');
    document.body.style.overflow='';
    /* clearing src is what actually stops YouTube playback behind the overlay */
    if(lbVideo){ lbVideo.src=''; }
    if(lbVideoWrap){ lbVideoWrap.hidden=true; }
    if(soloOpen()){ lb.classList.remove('is-solo','is-video'); return; }
    goSlide(lbIndex);
  }
  root.querySelector('[data-rf-lb-close]').onclick=closeLb;
  root.querySelector('[data-rf-lb-prev]').onclick=function(){lbGo(lbIndex-1);};
  root.querySelector('[data-rf-lb-next]').onclick=function(){lbGo(lbIndex+1);};
  /* Tapping beside the photo closes it. The old test was e.target===lb, but the
     stage fills the whole overlay, so every tap next to the image landed on the
     stage and nothing happened. Anything that is not the image, the video or a
     control counts as "outside" now. */
  lb.addEventListener('click',function(e){
    if(e.target.closest('[data-rf-lb-img],[data-rf-lb-videowrap],[data-rf-lb-prev],[data-rf-lb-next],[data-rf-lb-close]')) return;
    closeLb();
  });

  /* Swipe left and right through the photos. Threshold is 45px with the
     horizontal move at least 1.4x the vertical one, so scrolling the page by
     dragging over the image does not flip the picture by accident. */
  (function(){
    var stage = lb.querySelector('.rf-bb__lb-stage') || lb;
    var x0=0, y0=0, t0=0, live=false;
    stage.addEventListener('touchstart',function(e){
      if(soloOpen() || e.touches.length!==1){ live=false; return; }
      live=true; x0=e.touches[0].clientX; y0=e.touches[0].clientY; t0=Date.now();
    },{passive:true});
    stage.addEventListener('touchend',function(e){
      if(!live) return;
      live=false;
      var t=e.changedTouches[0];
      var dx=t.clientX-x0, dy=t.clientY-y0;
      if(Date.now()-t0>800) return;                   /* a long press is not a swipe */
      if(Math.abs(dx)<45 || Math.abs(dx)<Math.abs(dy)*1.4) return;
      lbGo(lbIndex + (dx<0 ? 1 : -1));
    },{passive:true});
  })();
  document.addEventListener('keydown',function(e){
    if(!lb.classList.contains('is-show')) return;
    if(e.key==='Escape') closeLb();
    if(soloOpen()) return;
    if(e.key==='ArrowRight') lbGo(lbIndex+1);
    if(e.key==='ArrowLeft') lbGo(lbIndex-1);
  });

  /* size guide: same lightbox, single image, no stepping */
  var fitImgBtn=root.querySelector('[data-rf-fitimg]');
  if(fitImgBtn){
    fitImgBtn.addEventListener('click',function(){
      lbImg.src=fitImgBtn.getAttribute('data-rf-full');
      lbImg.alt=fitImgBtn.getAttribute('data-rf-label');
      lbCount.textContent=fitImgBtn.getAttribute('data-rf-label');
      lb.classList.add('is-solo','is-show');
      document.body.style.overflow='hidden';
      track('fit_guide_open',{});
    });
  }

  /* brand video: same lightbox, iframe swapped in, src cleared on close */
  var videoBtn=root.querySelector('[data-rf-video]');
  if(videoBtn && lbVideo){
    videoBtn.addEventListener('click',function(){
      var id=videoBtn.getAttribute('data-rf-video');
      lbVideo.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0';
      lbVideoWrap.hidden=false;
      lbCount.textContent=videoBtn.getAttribute('data-rf-label');
      lb.classList.add('is-solo','is-video','is-show');
      document.body.style.overflow='hidden';
      track('video_open',{id:id});
    });
  }

  /* ---------- tiles ---------- */
  var clubBox=root.querySelector('[data-rf-tiles-club]');
  var putterBox=root.querySelector('[data-rf-tiles-putter]');
  var putterWrap=root.querySelector('[data-rf-putterwrap]');
  var setBox=root.querySelector('[data-rf-tiles-set]');
  var setWrap=root.querySelector('[data-rf-setwrap]');
  var notifyBox=root.querySelector('[data-rf-notify]');
  var notifyVariant=root.querySelector('[data-rf-notifyvariant]');

  function setPriceHtml(cents){
    var save=setSave(cents);
    return save>0 ? '<s>'+money(cents)+'</s> '+money(cents-save) : money(cents);
  }
  /* the gallery thumbs already hold one image per media index, so a tile can
     show the variant it will select without loading anything extra */
  function thumbSrc(i){
    var t = root.querySelector('[data-rf-thumb="'+i+'"] img');
    return t ? t.getAttribute('src') : '';
  }
  function tileHtml(v){
    var priceHtml = v.isSet ? setPriceHtml(v.price)
                  : (v.ok ? tag(v.price,false) : '&nbsp;');
    var pic = '';
    if(!v.isSet){
      var src = thumbSrc(v.mediaIndex);
      /* no loading="lazy": this is the same URL the gallery thumb already
         fetched, so it is a cache hit, and lazy left the tiles as empty frames
         because the browser had not decided the tile was visible yet */
      if(src) pic = '<span class="tpic"><img src="'+src+'" alt=""></span>';
    }
    var h='';
    if(v.isSet){
      /* the ladder row leads with how many, the way a buy-more block does.
         The only "reward" ever printed here is one that exists: a real
         discount when the store has one configured, otherwise the free
         shipping this order actually crosses. Nothing invented. */
      h+='<span class="tqty">'+v.count+' covers</span>';
    }
    h+=pic+'<b>'+v.name+'</b><span class="tprice">'+priceHtml+'</span>';
    if(v.isSet){
      /* one line, and it states the benefit — never "2 covers, one order" */
      h+='<span class="tsave">'+v.reason+'</span>';
    } else {
      h+='<span class="tstate">'+(v.ok?D.labels.inStock:D.labels.oos)+'</span>';
    }
    return h;
  }
  function buildTiles(){
    clubBox.innerHTML=''; putterBox.innerHTML=''; setBox.innerHTML='';
    variants.forEach(function(v){
      var b=document.createElement('button'); b.type='button';
      b.className='rf-bb__tile'+(v.ok?'':' is-oos')+(selected===v?' is-active':'');
      b.innerHTML=tileHtml(v);
      b.onclick=function(){
        if(!v.ok){
          notifyVariant.value = D.productTitle+' — '+v.name+' (restock request)';
          notifyBox.classList.add('is-open');
          track('notify_open',{variant:v.name});
          return;
        }
        notifyBox.classList.remove('is-open');
        selected=v; buildTiles(); sync();
        if(v.mediaIndex>=0 && v.mediaIndex<slides.length) goSlide(v.mediaIndex);
      };
      (v.group==='club'?clubBox:putterBox).appendChild(b);
    });
    putterWrap.hidden = variants.filter(function(v){return v.group==='putter';}).length===0;
    /* a product whose only variant is a mallet has nothing to put in the club
       block, and an empty headed block reads as a broken page */
    var clubWrap = clubBox.closest('.rf-bb__selector');
    if(clubWrap) clubWrap.hidden = variants.filter(function(v){return v.group==='club';}).length===0;
    if(window.RF_PDP && window.RF_PDP.hooks){
      window.RF_PDP.hooks.forEach(function(fn){ try{ fn(selected, variants, sets); }catch(e){} });
    }
    sets.forEach(function(s){
      var b=document.createElement('button'); b.type='button';
      b.className='rf-bb__tile'+(selected===s?' is-active':'')
        +(shipDomain(s.price)>=D.freeShip?' is-ship':'');
      b.innerHTML=tileHtml(s);
      b.onclick=function(){
        notifyBox.classList.remove('is-open');
        selected=s; buildTiles(); sync();
        track('set_option',{key:s.key,price:s.price});
      };
      setBox.appendChild(b);
    });
    setWrap.hidden = sets.length===0;
  }

  /* ---------- add-ons ---------- */
  var addonInputs=[].slice.call(root.querySelectorAll('[data-rf-addon]'));
  addonInputs.forEach(function(inp){
    inp.addEventListener('change',function(){
      track('addon_toggle',{item:inp.getAttribute('data-rf-addon-name'),on:inp.checked});
      sync();
    });
    var label=inp.closest('.rf-bb__addon');
    [].slice.call(label.querySelectorAll('[data-rf-swatch]')).forEach(function(sw){
      function pick(e){
        e.preventDefault();
        e.stopPropagation();     /* the swatch sits inside the add-on label */
        inp.setAttribute('data-rf-addon-id',sw.getAttribute('data-rf-swatch-id'));
        inp.setAttribute('data-rf-addon-price',sw.getAttribute('data-rf-swatch-price'));
        [].slice.call(sw.parentElement.children).forEach(function(x){
          var on = x===sw;
          x.classList.toggle('is-on',on);
          if(x.getAttribute('role')==='radio') x.setAttribute('aria-checked', on?'true':'false');
        });
        sync();
      }
      sw.addEventListener('click',pick);
      /* it is a radio now, so the keyboard has to work */
      sw.addEventListener('keydown',function(e){
        if(e.key===' '||e.key==='Enter') pick(e);
      });
    });
    /* render struck pair on the price tag when ad pricing is on */
    var tagEl=label.querySelector('[data-rf-addon-pricetag]');
    if(tagEl && MODE!=='none'){
      var base=+tagEl.getAttribute('data-rf-base');
      tagEl.innerHTML='<s>+'+money(base)+'</s> +'+money(disc(base));
    }
  });

  /* ---------- price sync ---------- */
  var priceEl=root.querySelector('[data-rf-price]');
  var priceNote=root.querySelector('[data-rf-pricenote]');
  var microEl=root.querySelector('[data-rf-micro]');
  var atcPrice=root.querySelector('[data-rf-atc-price]');
  var stickySub=root.querySelector('[data-rf-sticky-sub]');
  var stickyPrice=root.querySelector('[data-rf-sticky-price]');
  var shipHint=root.querySelector('[data-rf-shiphint]');

  function checkedAddons(){
    return addonInputs.filter(function(i){return i.checked;}).map(function(i){
      return { id:+i.getAttribute('data-rf-addon-id'), price:+i.getAttribute('data-rf-addon-price'), name:i.getAttribute('data-rf-addon-name') };
    });
  }
  function displayPrice(cents,isMulti){
    if(MODE==='all' || (MODE==='multi'&&isMulti)) return disc(cents);
    return cents;
  }
  var sync = function(){
    var adds=checkedAddons();
    var addFull=adds.reduce(function(a,x){return a+x.price;},0);
    var addDisp=adds.reduce(function(a,x){return a+displayPrice(x.price,true);},0);
    /* a selected set is priced by the same rule as its tile, so the buy box,
       the button and the tile can never disagree */
    var mainDisp=selected.isSet ? setNet(selected.price) : displayPrice(selected.price,false);
    priceEl.innerHTML=selected.isSet ? setPriceHtml(selected.price) : tag(selected.price,false);
    priceNote.textContent=selected.name;
    var total=money(mainDisp+addDisp);
    atcPrice.textContent=total;
    stickyPrice.textContent=total;
    stickySub.textContent=selected.name;
    var lines=(selected.isSet
      ? [selected.count+' covers, one order'].concat(D.microShared)
      : (selected.fit?[selected.fit]:[]).concat(D.microShared));
    microEl.innerHTML=lines.filter(Boolean).map(function(m){return '<li>'+m+'</li>';}).join('');
    /* quiet shipping line: appears only when this order genuinely ships free */
    var postDisc=shipDomain(selected.price+addFull);
    shipHint.textContent = (postDisc>=D.freeShip) ? D.labels.freeShipHit : '';
    /* express pay: only for a single plain variant, never for sets or add-ons */
    var express=root.querySelector('[data-rf-express]');
    if(express){
      var solo=!selected.isSet && adds.length===0;
      express.style.display=solo?'':'none';
      var idInput=express.querySelector('[data-rf-express-id]');
      if(idInput && !selected.isSet) idInput.value=selected.id;
    }
  }

  /* ---------- fit + gift ---------- */
  var fitBox=root.querySelector('[data-rf-fit]');
  var fitCopy=root.querySelector('[data-rf-fitcopy]');
  var fitStd=fitCopy.innerHTML;
  var fitToggle = root.querySelector('[data-rf-fittoggle]');
  fitToggle.onclick=function(){
    var open = fitBox.classList.toggle('is-open');
    fitToggle.setAttribute('aria-expanded', open?'true':'false');
  };
  var giftBtn=root.querySelector('[data-rf-gifttoggle]');
  var giftNote=root.querySelector('[data-rf-giftnote]');
  var promiseEl=root.querySelector('[data-rf-promise]');
  function setGift(on){
    giftOn=on;
    if(promiseEl) promiseEl.textContent = on ? D.labels.giftPromise : D.labels.promise;
    fitCopy.innerHTML = on ? '<b>'+D.labels.giftFitTitle+'</b> '+D.labels.giftFitBody : fitStd;
    fitBox.classList.toggle('is-open',on);
    if(giftNote) giftNote.hidden=!on;
    if(giftBtn) giftBtn.textContent = on ? D.labels.giftLinkOff : D.labels.giftLink;
    track('gift_mode',{on:on});
  }
  if(giftBtn) giftBtn.onclick=function(){ setGift(!giftOn); giftBtn.setAttribute('aria-expanded', giftOn?'true':'false'); };
  var qs=new URLSearchParams(location.search);
  if(qs.get('gift')==='1') setGift(true);
  /* the contact form reloads the page on submit — reopen the notify box so
     the success line is actually visible */
  if(qs.get('contact_posted')==='true'){
    notifyBox.classList.add('is-open');
    notifyBox.scrollIntoView({block:'center'});
  }

  /* Off the storefront there is no Shopify contact endpoint to post to, so the
     restock request degrades to a pre-filled email instead of a dead button. */
  var notifyForm=root.querySelector('[data-rf-notifyform]');
  if(notifyForm && !RFCART.onStore){
    notifyForm.addEventListener('submit',function(e){
      e.preventDefault();
      var mail=notifyForm.querySelector('input[type=email]');
      var what=notifyVariant.value||D.productTitle;
      var done=notifyForm.querySelector('[data-rf-notifydone]');
      if(done) done.hidden=false;
      window.location.href='mailto:customerservice@roseandfire.com'
        +'?subject='+encodeURIComponent('Restock request — '+what)
        +'&body='+encodeURIComponent('Please let me know the day this is back in stock.\n\n'
          +what+'\n'+((mail&&mail.value)||''));
    });
  }

  /* ---------- ATC via Shopify AJAX API ---------- */
  var atcBtn=root.querySelector('[data-rf-atc]');
  var atcBtn2=root.querySelector('[data-rf-atc2]');
  function itemsToAdd(){
    var items=[];
    var props=null;
    var noteEl=root.querySelector('[data-rf-giftnote-text]');
    if(giftOn && noteEl && noteEl.value.trim()) props={'Gift note':noteEl.value.trim().slice(0,250)};
    if(selected.isSet){
      selected.parts.forEach(function(p){ items.push({id:p.id,quantity:1,properties:props||undefined}); });
    } else {
      items.push({id:selected.id,quantity:1,properties:props||undefined});
    }
    checkedAddons().forEach(function(a){ items.push({id:a.id,quantity:1}); });
    return items;
  }
  function addToBag(){
    var items=itemsToAdd();
    if(!items.length) return;
    var noteEl=root.querySelector('[data-rf-giftnote-text]');
    var note=(giftOn && noteEl && noteEl.value.trim()) ? noteEl.value.trim() : '';
    atcBtn.disabled=true;
    track('atc',{main:selected.isSet?('set:'+selected.key):selected.name,items:items.length});
    RFCART.add(items,{
      note: note,
      redirect: D.cartRedirect,
      onDone: function(){
        atcBtn.disabled=false;
        atcBtn.classList.add('is-added');
        setTimeout(function(){atcBtn.classList.remove('is-added');},600);
        addonInputs.forEach(function(i){i.checked=false;});
        sync();
      },
      onFail: function(){ atcBtn.disabled=false; }
    });
  }
  /* A product whose every variant is gone still falls back to variants[0] so the
     page has something to render. It must not also be buyable: without this the
     button builds a Shopify permalink that 410s the whole cart. */
  function lockIfGone(){
    var gone = !selected.isSet && !selected.ok;
    atcBtn.disabled = gone;
    atcBtn.classList.toggle('is-gone', gone);
    if(atcBtn2){ atcBtn2.disabled = gone; }
    var lbl = root.querySelector('[data-rf-atc-label]');
    if(lbl) lbl.textContent = gone ? 'Sold out' : 'Add to bag';
    var pr = root.querySelector('[data-rf-atc-price]');
    if(pr && gone) pr.textContent = '';
    if(gone && notifyBox){
      notifyVariant.value = D.productTitle+' — '+selected.name+' (restock request)';
      notifyBox.classList.add('is-open');
    }
  }
  /* sync() rewrites the label and the price, and rf-site.js re-enables every add
     button when the page comes back from the bfcache, so the lock has to run
     after both of them rather than only on a tile rebuild. */
  var syncBeforeLock = sync;
  sync = function(){ syncBeforeLock.apply(this, arguments); lockIfGone(); };
  (window.RF_PDP.hooks = window.RF_PDP.hooks || []).push(lockIfGone);
  (window.RF_RESET = window.RF_RESET || []).push(lockIfGone);

  function addToBagGuarded(){
    if(!selected.isSet && !selected.ok) return;
    addToBag();
  }
  atcBtn.onclick=addToBagGuarded;
  if(atcBtn2) atcBtn2.onclick=addToBagGuarded;
  /* returning via the back button restores this page from the bfcache with the
     button still disabled; rerun sync so label, price and state are correct */
  (window.RF_RESET=window.RF_RESET||[]).push(function(){ atcBtn.disabled=false; sync(); });

  /* ---------- sticky bar ---------- */
  var sticky=root.querySelector('[data-rf-sticky]');
  new IntersectionObserver(function(entries){
    sticky.classList.toggle('is-show', !entries[0].isIntersecting);
  },{threshold:0}).observe(atcBtn);

  buildTiles();
  sync();

  /* ---------- live stock ----------
     rf-stock.js re-asks Shopify for price and availability on every load and
     hands the answer here. The buy box owns the tiles, the sets and the price,
     so it has to be the thing that redraws. */
  window.RF_PDP.selected = function(){ return selected; };
  window.RF_PDP.applyStock = function(stock){
    var changed = false;
    variants.forEach(function(v){
      var s = stock[String(v.id)];
      if(!s) return;
      var ok = !!s.a;
      if(v.ok !== ok || v.price !== s.c){ changed = true; }
      v.ok = ok;
      v.price = s.c;
    });
    if(!changed) return;
    /* the sets are derived from what is in stock, so they have to be rebuilt */
    availWoods = variants.filter(function(v){return v.group==='club'&&v.ok;});
    availAll   = variants.filter(function(v){return v.ok;});
    hasDriver  = availWoods.some(function(v){return /driver/i.test(v.title);});
    sets.length = 0;
    if(!D.noSets && hasDriver && availWoods.length>=2) sets.push(mkSet(availWoods,'woods',D.labels.setWoods));
    if(!D.noSets && availAll.length>=2) sets.push(mkSet(availAll,'all',D.labels.setAll));
    sets.forEach(function(s){
      var save=setSave(s.price);
      if(save>0){ s.reason='Save '+money(save); }
      else if(shipDomain(s.price)>=D.freeShip){ s.reason=D.labels.freeShipHit; }
      else { s.reason=D.labels.setReason; }
    });
    /* if what was selected has gone, fall to the first thing that is left */
    if(selected.isSet){
      if(sets.indexOf(selected)===-1) selected = variants.find(function(v){return v.ok;}) || variants[0];
    } else if(!selected.ok){
      selected = variants.find(function(v){return v.ok;}) || variants[0];
    }
    buildTiles();
    sync();
  };

  /* ---------- analytics ----------
     Fired once the buy box knows which variant is selected, so ViewContent and
     view_item carry the real id and price rather than the product's cheapest. */
  (function(){
    if(!window.RFTRACK) return;
    function ent(v){ return { id: v.id, qty: 1, info: { p: D.productTitle, v: v.name, c: v.price } }; }
    /* rf-site.js already fires the page view for every page, product pages included */
    RFTRACK.viewItem([ent(selected)]);
    /* Watching clicks does not work here: a tile's own handler calls buildTiles(),
       which removes the clicked button from the DOM before the event can bubble
       up to a delegated listener. Watch the model instead. */
    var lastId = selected.id;
    var sync0 = sync;
    sync = function(){
      sync0.apply(this, arguments);
      if(selected.isSet || selected.id === lastId) return;
      lastId = selected.id;
      RFTRACK.selectVariant(ent(selected));
    };
    /* gift mode and the video already push rf_gift_mode and rf_video_open through
       this section's own dataLayer tracker; adding RFTRACK calls would double them */
    if(notifyBox){
      var nf = root.querySelector('[data-rf-notifyform]');
      if(nf) nf.addEventListener('submit', function(){
        RFTRACK.notify(nf.getAttribute('data-rf-handle')||D.productTitle, notifyVariant.value);
      });
    }
  })();
})();

/* ---- */


/* ---- */

(function(){
  var root = document.querySelector('[data-rf-set]');
  if(!root) return;

  var cards   = root.querySelectorAll('.rf-set__card:not(.is-out)');
  var rowsBox = root.querySelector('[data-rf-rows]');
  var totalEl = root.querySelector('[data-rf-total]');
  var addBtn  = root.querySelector('[data-rf-add]');
  var tiers   = root.querySelectorAll('[data-rf-preset]');
  var picked  = {};
  var EMPTY   = "Nothing selected yet";
  var CTA     = "Add set to bag";
  var DISC    = 0;
  var SAVE_LABEL = "You save";

  window.dataLayer = window.dataLayer || [];
  function track(ev, data){ try{ dataLayer.push(Object.assign({event:'rf_'+ev}, data||{})); }catch(e){} }

  function money(cents){
    return '${{amount}}'.replace(/\{\{\s*amount[^}]*\}\}/, (cents/100).toFixed(2).replace(/\.00$/,''));
  }
  function disc(cents){ return Math.round(cents*(1-DISC)); }

  function sync(){
    var ids = Object.keys(picked), total = 0, full = 0, html = '';
    ids.forEach(function(id){
      full  += picked[id].price;
      total += disc(picked[id].price);
      var priceHtml = DISC ? '<span><s>'+money(picked[id].price)+'</s> '+money(disc(picked[id].price))+'</span>'
                           : '<span>'+money(picked[id].price)+'</span>';
      html += '<div class="rf-set__row"><span>'+picked[id].name+'</span>'+priceHtml+'</div>';
    });
    if(DISC && ids.length){
      html += '<div class="rf-set__row rf-set__row--save"><span>'+SAVE_LABEL+'</span><span>'+money(full-total)+'</span></div>';
    }
    rowsBox.innerHTML = ids.length ? html : '<div class="rf-set__row rf-set__row--muted"><span>'+EMPTY+'</span></div>';
    totalEl.textContent = money(total);
    addBtn.disabled = ids.length === 0;
  }

  cards.forEach(function(card){
    card.addEventListener('click', function(){
      var id = card.getAttribute('data-rf-variant');
      if(picked[id]){ delete picked[id]; card.classList.remove('is-selected'); }
      else {
        picked[id] = {
          price: parseInt(card.getAttribute('data-rf-price'), 10),
          name:  card.querySelector('.rf-set__name').textContent.trim()
        };
        card.classList.add('is-selected');
      }
      tiers.forEach(function(t){ t.classList.remove('is-active'); });
      sync();
    });
  });

  tiers.forEach(function(tier){
    tier.addEventListener('click', function(){
      picked = {};
      cards.forEach(function(c){ c.classList.remove('is-selected'); });
      tiers.forEach(function(t){ t.classList.remove('is-active'); });
      if(tier.getAttribute('data-rf-preset') === 'all'){
        cards.forEach(function(c){ c.click(); });
        tiers.forEach(function(t){ t.classList.remove('is-active'); });
        tier.classList.add('is-active');
      }
      sync();
    });
  });

  addBtn.addEventListener('click', function(){
    var items = Object.keys(picked).map(function(id){ return { id: parseInt(id,10), quantity: 1 }; });
    if(!items.length) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    track('set_builder_add',{count:items.length});
    RFCART.add(items, {
      onDone: function(){ addBtn.textContent = CTA; addBtn.disabled = false; },
      onFail: function(){ addBtn.textContent = CTA; addBtn.disabled = false; }
    });
  });

  (window.RF_RESET=window.RF_RESET||[]).push(function(){
    addBtn.textContent = CTA;
    sync();
  });

  sync();
})();

/* ---- */


/* ---- */

(function(){
  var root=document.querySelector('[data-rf-x]');
  if(!root) return;
  window.dataLayer=window.dataLayer||[];
  function track(ev,data){try{dataLayer.push(Object.assign({event:'rf_'+ev},data||{}));}catch(e){}}
  [].slice.call(root.querySelectorAll('[data-rf-xopen]')).forEach(function(btn){
    btn.addEventListener('click',function(){
      btn.closest('[data-rf-xcard]').classList.add('is-open');
      track('xsell_open',{});
    });
  });
  [].slice.call(root.querySelectorAll('[data-rf-xadd]')).forEach(function(pill){
    pill.addEventListener('click',function(){
      pill.disabled=true;
      track('xsell_add',{item:pill.getAttribute('data-rf-xname')});
      RFCART.add([{id:parseInt(pill.getAttribute('data-rf-xadd'),10),quantity:1}],{
        onDone: function(){
          pill.disabled=false;
          pill.closest('[data-rf-xcard]').classList.remove('is-open');
        },
        onFail: function(){ pill.disabled=false; }
      });
    });
  });
})();
